import {FormattedDate, FormattedTime} from "react-intl";

export type DateTimeProps = {
    value: Date | string | undefined | null;
    short?: boolean
};

function getDt(value: Date | string): Date {
    if (value instanceof Date) {
        return value;
    } else {
        return new window.Date(value);
    }
}

export function Date(props: DateTimeProps) {
    if (!props.value) {
        return null;
    }

    const dt = getDt(props.value);
    const now = new window.Date();

    const fmt = new Intl.DateTimeFormat(undefined, {
        year: undefined,
        month: "numeric",
        day: "numeric",
    });

    if (props.short && dt.getFullYear() === now.getFullYear()) {
        return <span class="datetime date">{fmt.format(dt)}</span>;
    } else {
        return <span class="datetime date"><FormattedDate value={dt}/></span>;
    }
}

export function YearMonth(props: DateTimeProps) {
    if (!props.value) {
        return null;
    }

    const dt = getDt(props.value);
    return <span class="datetime date"><FormattedDate value={dt} month="numeric" year="numeric" /></span>
}

export function Year(props: DateTimeProps) {
    if (!props.value) {
        return null;
    }

    const dt = getDt(props.value);
    return <span class="datetime date"><FormattedDate value={dt} year="numeric" /></span>
}

export function Time(props: DateTimeProps) {
    if (!props.value) {
        return null;
    }

    return <span class="datetime time"><FormattedTime value={getDt(props.value)} /></span>;
}

export function DateTime(props: DateTimeProps) {
    if (!props.value) {
        return null;
    }

    return <span class="datetime"><Date {...props} /> <Time {...props} /></span>
}
